export default __webpack_public_path__ + "static/6735-2a47030f3ffaed7f07d14e36d2a3850f.jpg";